import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useComparison } from '../../../context/ComparisonContext';
import VariantDetailRow from '../VariantDetailRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        width: '24%'
    },
}));

const iconStyle = {
    width: '13px',
    transform: 'scale(1.5)'
}

export default function StandardFeature() {
    const { comparisions } = useComparison();
    const [rows, setRows] = useState(null);

    useEffect(() => {
        const rows = comparisions.map((item) => {
            return item.variants.filter((variant) => variant.variantid === item.variant);
        });
        setRows(rows);
    }, [comparisions])

    const getIcon = check => check == "Yes" ? <img style={iconStyle} src='https://tradebhp.com/images/icon/check-green.png' /> : <img style={iconStyle} src='https://tradebhp.com/images/icon/cross-red.png' />

    if (rows) {
        return (
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell className='react-table-heading'>Standard Features</StyledTableCell>
                            {rows.map((row) => (
                                <StyledTableCell className='react-table-heading' align="center" key={row[0].variantid}>{row[0].variantid}</StyledTableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <VariantDetailRow title="Air Conditioner" values={
                            [
                                getIcon(rows[0][0].air_conditioner),
                                getIcon(rows[1][0].air_conditioner),
                                (rows[2]) && getIcon(rows[2][0].air_conditioner)
                            ]
                        } />

                        <VariantDetailRow title="AntiLock Braking System" values={
                            [
                                getIcon(rows[0][0].anti_lock_braking_system),
                                getIcon(rows[1][0].anti_lock_braking_system),
                                (rows[2]) && getIcon(rows[2][0].anti_lock_braking_system)
                            ]
                        } />

                        <VariantDetailRow title="Power Steering" values={
                            [
                                getIcon(rows[0][0].power_steering),
                                getIcon(rows[1][0].power_steering),
                                (rows[2]) && getIcon(rows[2][0].power_steering)
                            ]
                        } />

                        <VariantDetailRow title="Power Windows Rear" values={
                            [
                                getIcon(rows[0][0].power_windows_rear),
                                getIcon(rows[1][0].power_windows_rear),
                                (rows[2]) && getIcon(rows[2][0].power_windows_rear)
                            ]
                        } />

                        <VariantDetailRow title="Leather Seats" values={
                            [
                                getIcon(rows[0][0].leather_seats),
                                getIcon(rows[1][0].leather_seats),
                                (rows[2]) && getIcon(rows[2][0].leather_seats)
                            ]
                        } />

                        <VariantDetailRow title="Central Locking" values={
                            [
                                getIcon(rows[0][0].central_locking),
                                getIcon(rows[1][0].central_locking),
                                (rows[2]) && getIcon(rows[2][0].central_locking)
                            ]
                        } />

                        <VariantDetailRow title="Speed Sensing Auto Door Lock" values={
                            [
                                getIcon(rows[0][0].speed_sensing_auto_door_lock),
                                getIcon(rows[1][0].speed_sensing_auto_door_lock),
                                (rows[2]) && getIcon(rows[2][0].speed_sensing_auto_door_lock)
                            ]
                        } />

                        <VariantDetailRow title="Impact Sensing Auto Door Unlock" values={
                            [
                                getIcon(rows[0][0].impact_sensing_auto_door_unlock),
                                getIcon(rows[1][0].impact_sensing_auto_door_unlock),
                                (rows[2]) && getIcon(rows[2][0].impact_sensing_auto_door_unlock)
                            ]
                        } />
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
